// extracted by mini-css-extract-plugin
module.exports = {"component":"index_component__2u52p","head":"index_head__3Gi_N","head_crumbs":"index_head_crumbs__3d8WO","head_line":"index_head_line__35wok"};